/**
 * @return {string[]}
 */
module.exports = function getSilentBlockedEmailDomains() {
    let silentBlockedEmailDomains = "";

    if ("silent_blocked_email_domains" in window.ITBL) {
        const silentBlockedEmailDomainsBase64 = window.ITBL.silent_blocked_email_domains || "";
        silentBlockedEmailDomains = atob(silentBlockedEmailDomainsBase64, true);
    }

    return silentBlockedEmailDomains.split(",");
}